document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-mt-producto]').forEach(initProducto);
});

function initProducto(root) {
  initGaleria(root);
  const bundle = root.querySelector('[data-mt-bundle]');
  if (bundle) initBundle(bundle);
  const simple = root.querySelector('[data-mt-simple]');
  if (simple) initSimple(simple);
  initStickyCta(root);
  initMascotas(root);
  initFinalCta(root);
}

function initFinalCta(root) {
  const finalBtn = root.querySelector('[data-mt-final-cta-btn]');
  const tiers = root.querySelector('[data-mt-tiers], [data-mt-simple]');
  const target = tiers || root.querySelector('[data-mt-bundle-submit], [data-mt-simple-submit]');
  if (!finalBtn || !target) return;
  finalBtn.addEventListener('click', () => {
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    target.classList.add('mt-highlight-pulse');
    setTimeout(() => target.classList.remove('mt-highlight-pulse'), 1600);
  });
}

function initMascotas(root) {
  const track = root.querySelector('[data-mt-mascotas-track]');
  const slides = track ? Array.from(track.children) : [];
  if (!track || slides.length < 3) return;

  const realCount = slides.length - 1;
  let index = 0;
  let timer = null;
  let resumeTimer = null;

  function tick() {
    index = (index + 1) % slides.length;
    const slide = slides[index];
    if (!slide) {
      index = 0;
      return;
    }
    track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    if (index === realCount) {
      setTimeout(() => {
        track.scrollTo({ left: slides[0].offsetLeft, behavior: 'auto' });
        index = 0;
      }, 500);
    }
  }
  function start() {
    stop();
    timer = setInterval(tick, 3000);
  }
  function stop() {
    if (timer) clearInterval(timer);
    timer = null;
  }
  function pauseThenResume() {
    stop();
    if (resumeTimer) clearTimeout(resumeTimer);
    resumeTimer = setTimeout(start, 2000);
  }

  track.addEventListener('pointerdown', pauseThenResume);
  track.addEventListener('touchstart', pauseThenResume, { passive: true });

  if (!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
    start();
  }
}

function initStickyCta(root) {
  const stickyBar = root.querySelector('[data-mt-sticky-cta]');
  const mainBtn = root.querySelector('[data-mt-bundle-submit], [data-mt-simple-submit]');
  if (!stickyBar || !mainBtn) return;

  const stickyBtn = stickyBar.querySelector('[data-mt-sticky-btn]');
  const stickyPrice = stickyBar.querySelector('[data-mt-sticky-price]');
  const stickyPriceWas = stickyBar.querySelector('[data-mt-sticky-price-was]');

  stickyBtn?.addEventListener('click', () => mainBtn.click());

  const syncPrice = () => {
    const activo = root.querySelector('.mt-tier-activa [data-mt-tier-price]') || root.querySelector('[data-mt-simple-price]');
    if (activo && stickyPrice) stickyPrice.textContent = activo.textContent;

    const activoWas = root.querySelector('.mt-tier-activa [data-mt-tier-compare]') || root.querySelector('[data-mt-simple-compare]');
    if (stickyPriceWas) {
      if (activoWas && activoWas.textContent.trim()) {
        stickyPriceWas.textContent = activoWas.textContent;
        stickyPriceWas.hidden = false;
      } else {
        stickyPriceWas.hidden = true;
      }
    }
  };
  syncPrice();
  root.querySelectorAll('[data-mt-tier], [data-mt-simple-variant]').forEach((el) => {
    el.addEventListener('click', () => setTimeout(syncPrice, 0));
  });

  if (!('IntersectionObserver' in window)) return;
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        stickyBar.hidden = entry.isIntersecting;
      });
    },
    { threshold: 0 }
  );
  observer.observe(mainBtn);
}

function initGaleria(root) {
  const galeria = root.querySelector('[data-mt-galeria]');
  if (!galeria) return;

  const track = galeria.querySelector('[data-mt-galeria-track]');
  const slides = Array.from(track.querySelectorAll('.mt-galeria-slide'));
  const prevBtn = galeria.querySelector('[data-mt-galeria-prev]');
  const nextBtn = galeria.querySelector('[data-mt-galeria-next]');
  const dots = Array.from(galeria.querySelectorAll('[data-mt-galeria-dot]'));
  const thumbs = Array.from(root.querySelectorAll('[data-mt-thumb]'));
  if (!slides.length) return;

  let indiceActual = 0;

  function marcarActivo(indice) {
    indiceActual = indice;
    dots.forEach((d, i) => d.classList.toggle('mt-galeria-dot-activo', i === indice));
    thumbs.forEach((t, i) => t.classList.toggle('mt-thumb-activo', i === indice));
  }

  function irA(indice) {
    indice = Math.max(0, Math.min(indice, slides.length - 1));
    marcarActivo(indice);
    track.scrollTo({ left: slides[indice].offsetLeft, behavior: 'smooth' });
  }

  prevBtn?.addEventListener('click', () => irA(indiceActual - 1));
  nextBtn?.addEventListener('click', () => irA(indiceActual + 1));
  dots.forEach((dot, i) => dot.addEventListener('click', () => irA(i)));
  thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => irA(i)));

  galeria.mtIrA = irA;
  galeria.mtSlideSrcs = slides.map((s) => {
    const img = s.querySelector('img');
    return img ? img.currentSrc || img.src : '';
  });

  let scrollTimeout;
  track.addEventListener(
    'scroll',
    () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        const centro = track.scrollLeft + track.clientWidth / 2;
        let masCercano = 0;
        let distMin = Infinity;
        slides.forEach((slide, i) => {
          const centroSlide = slide.offsetLeft + slide.clientWidth / 2;
          const dist = Math.abs(centro - centroSlide);
          if (dist < distMin) {
            distMin = dist;
            masCercano = i;
          }
        });
        marcarActivo(masCercano);
      }, 100);
    },
    { passive: true }
  );

  track.querySelectorAll('video').forEach((video) => {
    video.addEventListener('play', () => {
      if (typeof video.webkitEnterFullscreen === 'function') {
        video.webkitEnterFullscreen();
      } else if (typeof video.requestFullscreen === 'function') {
        video.requestFullscreen().catch(() => {});
      } else if (typeof video.webkitRequestFullscreen === 'function') {
        video.webkitRequestFullscreen();
      }
    });
    const salirDePantallaCompleta = () => {
      const enPantallaCompleta = document.fullscreenElement === video || document.webkitFullscreenElement === video;
      if (!enPantallaCompleta && !video.paused) video.pause();
    };
    document.addEventListener('fullscreenchange', salirDePantallaCompleta);
    document.addEventListener('webkitfullscreenchange', salirDePantallaCompleta);
    video.addEventListener('webkitendfullscreen', () => video.pause());
  });
}

function actualizarCarritoUI(cart, respuesta) {
  if (!cart || typeof cart.getSectionsToRender !== 'function' || !respuesta.sections) {
    window.location = window.routes.cart_url;
    return;
  }

  const primerItem = Array.isArray(respuesta.items) ? respuesta.items[0] : respuesta;
  if (primerItem) cart.cartItemKey = primerItem.key;

  cart.getSectionsToRender().forEach((section) => {
    const el = document.getElementById(section.id);
    const html = respuesta.sections[section.id];
    if (!el || !html) return;
    try {
      const parsed = new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector || '.shopify-section');
      if (parsed) el.innerHTML = parsed.innerHTML;
    } catch (e) {
      // seccion sin coincidencia (p.ej. vista previa de un solo producto en un alta multi-item): se omite sin romper el resto
    }
  });

  if (typeof cart.open === 'function') cart.open();
}

function initSimple(root) {
  const variantesScript = root.querySelector('[data-mt-simple-variantes]');
  let variantes = [];
  if (variantesScript) {
    try {
      variantes = JSON.parse(variantesScript.textContent);
    } catch (e) {
      variantes = [];
    }
  }

  const botones = Array.from(root.querySelectorAll('[data-mt-simple-variant]'));
  const submitBtn = root.querySelector('[data-mt-simple-submit]');
  const errorBox = root.querySelector('[data-mt-simple-error]');
  const precioNow = root.querySelector('[data-mt-simple-price]');
  const precioWas = root.querySelector('[data-mt-simple-compare]');
  const galeria = root.closest('[data-mt-producto]')?.querySelector('[data-mt-galeria-track]');

  function encontrarVariante(id) {
    return variantes.find((v) => String(v.id) === String(id));
  }

  botones.forEach((boton) => {
    boton.addEventListener('click', () => {
      if (boton.hasAttribute('disabled')) return;
      botones.forEach((b) => b.classList.remove('mt-simple-variant-activa'));
      boton.classList.add('mt-simple-variant-activa');

      const id = boton.getAttribute('data-variant-id');
      if (submitBtn) submitBtn.setAttribute('data-variant-id', id);

      const variante = encontrarVariante(id);
      if (variante && precioNow) precioNow.textContent = variante.priceHtml;
      if (precioWas) {
        if (variante && variante.showCompare) {
          precioWas.textContent = variante.compareHtml;
          precioWas.style.display = '';
        } else {
          precioWas.style.display = 'none';
        }
      }

      const imagenUrl = boton.getAttribute('data-variant-image');
      if (imagenUrl && galeria) {
        const primeraImg = galeria.querySelector('.mt-galeria-slide img');
        if (primeraImg) primeraImg.src = imagenUrl;
      }
    });
  });

  function mostrarError(mensaje) {
    if (!errorBox) return;
    errorBox.textContent = mensaje;
    errorBox.style.display = mensaje ? 'block' : 'none';
  }

  submitBtn?.addEventListener('click', () => {
    const id = submitBtn.getAttribute('data-variant-id');
    if (!id) {
      mostrarError('Selecciona una opción válida.');
      return;
    }

    mostrarError('');
    submitBtn.setAttribute('aria-disabled', 'true');
    submitBtn.querySelector('.loading__spinner')?.classList.remove('hidden');

    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const body = { items: [{ id, quantity: 1 }] };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map((s) => s.id);
      body.sections_url = window.location.pathname;
    }

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(body),
    })
      .then((r) => r.json())
      .then((respuesta) => {
        if (respuesta.status) {
          mostrarError(respuesta.description || respuesta.message || 'No se pudo añadir al carrito.');
          return;
        }
        actualizarCarritoUI(cart, respuesta);
      })
      .catch(() => mostrarError('Error de red. Inténtalo de nuevo.'))
      .finally(() => {
        submitBtn.removeAttribute('aria-disabled');
        submitBtn.querySelector('.loading__spinner')?.classList.add('hidden');
      });
  });
}

function initBundle(root) {
  const kitScript = root.querySelector('[data-mt-kit-variantes]');
  const addonScript = root.querySelector('[data-mt-addon-variantes]');
  if (!kitScript) return;

  let kitVariantes = [];
  let addonVariantes = [];
  try {
    kitVariantes = JSON.parse(kitScript.textContent);
  } catch (e) {
    return;
  }
  if (addonScript) {
    try {
      addonVariantes = JSON.parse(addonScript.textContent);
    } catch (e) {
      addonVariantes = [];
    }
  }

  const tierCards = root.querySelectorAll('[data-mt-tier]');
  const addonCard = root.querySelector('[data-mt-addon]');
  const addonColorSelect = root.querySelector('[data-mt-addon-color]');
  const addonImage = root.querySelector('[data-mt-addon-image]');
  const submitBtn = root.querySelector('[data-mt-bundle-submit]');
  const errorBox = root.querySelector('[data-mt-bundle-error]');
  const galeria = root.closest('[data-mt-producto]')?.querySelector('[data-mt-galeria]');

  function encontrarVariante(pack, color) {
    return kitVariantes.find((v) => v.pack === pack && v.color === color);
  }
  function encontrarAddon(color) {
    return addonVariantes.find((v) => v.color === color);
  }

  function nombreArchivo(url) {
    if (!url) return '';
    return url.split('/').pop().split('?')[0];
  }

  function actualizarImagenPrincipal(pack, color) {
    const variante = encontrarVariante(pack, color);
    if (!variante || !variante.image || !galeria) return;
    if (typeof galeria.mtIrA === 'function' && Array.isArray(galeria.mtSlideSrcs)) {
      const objetivo = nombreArchivo(variante.image);
      const indice = galeria.mtSlideSrcs.findIndex((src) => nombreArchivo(src) === objetivo);
      if (indice !== -1) {
        galeria.mtIrA(indice);
        return;
      }
    }
    const primeraImg = galeria.querySelector('.mt-galeria-slide img');
    if (primeraImg) primeraImg.src = variante.image;
  }

  const cerrarPickers = [];
  function cerrarTodosLosPickers() {
    cerrarPickers.forEach((fn) => fn());
  }
  document.addEventListener('click', cerrarTodosLosPickers);

  tierCards.forEach((card) => {
    const radio = card.querySelector('[data-mt-tier-radio]');
    const colorSelects = card.querySelectorAll('[data-mt-tier-color]');
    const pack = card.getAttribute('data-pack');

    card.addEventListener('click', (evt) => {
      if (Array.from(colorSelects).includes(evt.target)) return;
      tierCards.forEach((c) => {
        c.classList.remove('mt-tier-activa');
        const r = c.querySelector('[data-mt-tier-radio]');
        if (r) r.checked = false;
      });
      card.classList.add('mt-tier-activa');
      if (radio) radio.checked = true;
      if (colorSelects.length) actualizarImagenPrincipal(pack, colorSelects[0].value);
    });

    colorSelects.forEach((select, i) => {
      select.addEventListener('click', (evt) => evt.stopPropagation());
      select.addEventListener('change', () => {
        if (i === 0) actualizarImagenPrincipal(pack, select.value);
      });
    });

    const pickers = Array.from(card.querySelectorAll('[data-mt-breed-picker]'));
    pickers.forEach((picker) => {
      const trigger = picker.querySelector('[data-mt-breed-trigger]');
      const thumb = picker.querySelector('[data-mt-breed-trigger-thumb]');
      const nameEl = picker.querySelector('[data-mt-breed-trigger-name]');
      const list = picker.querySelector('[data-mt-breed-list]');
      const select = picker.querySelector('[data-mt-tier-color]');
      const options = Array.from(picker.querySelectorAll('[data-mt-breed-option]'));
      if (!trigger || !list || !select) return;

      function cerrar() {
        list.hidden = true;
        picker.removeAttribute('data-abierto');
        trigger.setAttribute('aria-expanded', 'false');
      }
      function abrir() {
        cerrarTodosLosPickers();
        list.hidden = false;
        picker.setAttribute('data-abierto', '');
        trigger.setAttribute('aria-expanded', 'true');
      }
      cerrarPickers.push(cerrar);

      picker.addEventListener('click', (evt) => evt.stopPropagation());
      trigger.addEventListener('click', () => {
        if (list.hidden) abrir();
        else cerrar();
      });

      options.forEach((opt) => {
        opt.addEventListener('click', () => {
          const value = opt.getAttribute('data-value');
          select.value = value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          const optThumb = opt.querySelector('.mt-breed-picker-thumb');
          if (thumb && optThumb) thumb.style.backgroundImage = optThumb.style.backgroundImage;
          if (nameEl) nameEl.textContent = value;
          options.forEach((o) => {
            o.classList.remove('mt-breed-picker-option-activa');
            o.setAttribute('aria-selected', 'false');
          });
          opt.classList.add('mt-breed-picker-option-activa');
          opt.setAttribute('aria-selected', 'true');
          cerrar();
        });
      });
    });
  });

  if (addonCard) {
    const alternarAddon = () => {
      const activo = addonCard.classList.toggle('mt-addon-activa');
      addonCard.setAttribute('aria-pressed', activo ? 'true' : 'false');
    };
    addonCard.addEventListener('click', (evt) => {
      if (evt.target === addonColorSelect) return;
      alternarAddon();
    });
    addonCard.addEventListener('keydown', (evt) => {
      if (evt.target === addonColorSelect) return;
      if (evt.key === 'Enter' || evt.key === ' ') {
        evt.preventDefault();
        alternarAddon();
      }
    });
    addonColorSelect?.addEventListener('click', (evt) => evt.stopPropagation());
    addonColorSelect?.addEventListener('change', () => {
      const addonVariante = encontrarAddon(addonColorSelect.value);
      if (addonVariante && addonVariante.image && addonImage) {
        addonImage.src = addonVariante.image;
      }
    });
  }

  function mostrarError(mensaje) {
    if (!errorBox) return;
    errorBox.textContent = mensaje;
    errorBox.style.display = mensaje ? 'block' : 'none';
  }

  function construirItems() {
    const tarjetaActiva = root.querySelector('.mt-tier-activa');
    if (!tarjetaActiva) return null;

    const pack = tarjetaActiva.getAttribute('data-pack');
    const colorSelects = Array.from(tarjetaActiva.querySelectorAll('[data-mt-tier-color]'));
    const colorPrincipal = colorSelects.length ? colorSelects[0].value : 'Negro';
    const kitVariante = encontrarVariante(pack, colorPrincipal);
    if (!kitVariante) {
      mostrarError('Selecciona una opción válida.');
      return null;
    }

    const kitItem = { id: kitVariante.id, quantity: 1 };
    if (colorSelects.length > 1) {
      // El primer marco ya queda reflejado en la variante (opción de color),
      // así que solo añadimos como propiedad el resto de marcos para no duplicar el dato.
      const colorLabel = root.getAttribute('data-mt-color-label') || 'Color';
      const properties = {};
      colorSelects.slice(1).forEach((select, i) => {
        properties[`${colorLabel} #${i + 2}`] = select.value;
      });
      kitItem.properties = properties;
    }

    const items = [kitItem];

    if (addonCard && addonCard.classList.contains('mt-addon-activa')) {
      const addonColor = addonColorSelect ? addonColorSelect.value : null;
      const addonVariante = encontrarAddon(addonColor);
      if (addonVariante) items.push({ id: addonVariante.id, quantity: 1 });
    }

    return items;
  }

  submitBtn?.addEventListener('click', () => {
    const items = construirItems();
    if (!items) return;

    mostrarError('');
    submitBtn.setAttribute('aria-disabled', 'true');
    submitBtn.querySelector('.loading__spinner')?.classList.remove('hidden');

    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const body = { items };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map((s) => s.id);
      body.sections_url = window.location.pathname;
    }

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(body),
    })
      .then((r) => r.json())
      .then((respuesta) => {
        if (respuesta.status) {
          mostrarError(respuesta.description || respuesta.message || 'No se pudo añadir al carrito.');
          return;
        }
        actualizarCarritoUI(cart, respuesta);
      })
      .catch(() => mostrarError('Error de red. Inténtalo de nuevo.'))
      .finally(() => {
        submitBtn.removeAttribute('aria-disabled');
        submitBtn.querySelector('.loading__spinner')?.classList.add('hidden');
      });
  });

  const buyNowBtn = root.querySelector('[data-mt-bundle-buy-now]');
  buyNowBtn?.addEventListener('click', () => {
    const items = construirItems();
    if (!items) return;

    mostrarError('');
    buyNowBtn.setAttribute('aria-disabled', 'true');
    buyNowBtn.querySelector('.loading__spinner')?.classList.remove('hidden');

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ items }),
    })
      .then((r) => r.json())
      .then((respuesta) => {
        if (respuesta.status) {
          mostrarError(respuesta.description || respuesta.message || 'No se pudo añadir al carrito.');
          buyNowBtn.removeAttribute('aria-disabled');
          buyNowBtn.querySelector('.loading__spinner')?.classList.add('hidden');
          return;
        }
        // routes.checkout_url doesn't exist in Dawn's routes object; derive a
        // locale-aware checkout path from cart_url (e.g. "/de/cart" -> "/de/checkout")
        // instead of a bare "/checkout", which always lands on the shop's
        // default locale regardless of the language the visitor was browsing in.
        const mtCartUrl = (window.routes && window.routes.cart_url) || '/cart';
        window.location = mtCartUrl.replace(/\/cart\/?$/, '/checkout');
      })
      .catch(() => {
        mostrarError('Error de red. Inténtalo de nuevo.');
        buyNowBtn.removeAttribute('aria-disabled');
        buyNowBtn.querySelector('.loading__spinner')?.classList.add('hidden');
      });
  });
}
